import { useGlobalContext } from '../context'

function DeadFucker() {
    const { players, index, guessDeath, vote,turns, openWaitingScreen} = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Dead fucker)</h4>
            <p className='text-center'>You are a deadfucker, and you love fucking dead people?!I know it sounds disgusting (if doesn't please see a therapist) but,
            you have a very special power, a power that lets you guess who is going to die each round and if you get it right you get an extra life!
            What is cooler than that?And lastly, don't forget that you're still on the villager team.Even tough you want them dead... </p>
            <div className='d-flex'>
                <img src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                        return (<button disabled={vote || currentPlayer.angel ? 'disabled' : ''} className={turns === 0 ? 'hidden' : 'btn btn-dark'} onClick={(e) => { guessDeath(index); e.target.classList.add('selected') }} key={index}>{`${player.name}`}</button>)         
                    })
                }
            </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default DeadFucker;